import React, { useState } from 'react';
import { Button } from '../button/button';
import { Modal } from '../modal/modal';
import SubscriptionService from '../../utilities/services/subscription-service';
import { useAuthState } from '../../utilities/contexts/auth-state-context';
import HubspotSubCancellationDataService from '../../utilities/services/hubspot-sub-cancellation-data-service';
import { HubspotSubCancellationData } from '../../models/interfaces/hubspot-sub-cancellation-data';
import { enqueueSnackbar } from 'notistack';
// @ts-ignore
import HubspotForm from "react-hubspot-form";
import { TextTypeInput } from '../forms';
import { useForm } from 'react-hook-form';
import { CheckboxTypeInput } from '../forms/checkbox-type-input';
import RadioTypeInput from '../forms/radio-type-input/radio-type-input';
import { useTranslation } from 'react-i18next';
interface CancellationDialogBoxProps {
  isOpen: boolean;
  onClose: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  isLoading?: boolean;
  cancelButtonAction?: Function;
}

const COMPONENT_CLASS = "c-cancellation-dialog-box";

const CancellationDialogBox: React.FC<CancellationDialogBoxProps> = (props) => {
  const {
    isOpen,
    onClose,
    title,
    isLoading,
    cancelButtonAction
  } = props;

  const methods = useForm<any>();

  const {
    register,
  } = methods;

  const { state } = useAuthState();
  const [openPlanCancellationAgreement, setOpenPlanCancellationAgreement] = useState(false);
  const [selectedReason, setSelectedReason] = useState<number | null>(null);
  const [details, setDetails] = useState('');
  const [openHubspotForm, setOpenHubspotForm] = useState(false);
  const [checkedBoxesNumber, setCheckedBoxesNumber] = useState(0);
  const { t } = useTranslation();
  const [checkboxes, setCheckboxes] = useState([
    { firstLine: t('cancellationDialogBox.checkbox_1_title'), secondLine: t('cancellationDialogBox.checkbox_1_desc'), isChecked: false },
    { firstLine: t('cancellationDialogBox.checkbox_2_title'), secondLine: t('cancellationDialogBox.checkbox_2_desc'), isChecked: false },
    { firstLine: t('cancellationDialogBox.checkbox_3_title'), secondLine: t('cancellationDialogBox.checkbox_3_desc'), isChecked: false },
  ])

  const resetCheckboxes = () => {
    setCheckboxes([
      { firstLine: t('cancellationDialogBox.checkbox_1_title'), secondLine: t('cancellationDialogBox.checkbox_1_desc'), isChecked: false },
      { firstLine: t('cancellationDialogBox.checkbox_2_title'), secondLine: t('cancellationDialogBox.checkbox_2_desc'), isChecked: false },
      { firstLine: t('cancellationDialogBox.checkbox_3_title'), secondLine: t('cancellationDialogBox.checkbox_3_desc'), isChecked: false },
    ])
  }

  const reasons = [
    { value: t('cancellationDialogBox.reasons.tool'), text: t('cancellationDialogBox.reasons.tool_desc'), placeholder: t('cancellationDialogBox.reasons.tool_placeholder') },
    { value: t('cancellationDialogBox.reasons.features'), text: t('cancellationDialogBox.reasons.features_desc'), placeholder: t('cancellationDialogBox.reasons.features_placeholder') },
    { value: t('cancellationDialogBox.reasons.price'), text: t('cancellationDialogBox.reasons.price_desc'), placeholder: t('cancellationDialogBox.reasons.price_placeholder') },
    { value: t('cancellationDialogBox.reasons.other'), text: t('cancellationDialogBox.reasons.other_desc'), placeholder: t('cancellationDialogBox.reasons.other_placeholder') }];

  const handleRadioChange = (reason: number) => {
    setSelectedReason((prev) => prev === reason ? null : reason);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const { checked } = e.target;
    const newCheckBoxes = [...checkboxes]
    newCheckBoxes[index].isChecked = checked
    setCheckboxes(newCheckBoxes);

    if (checked) {
      setCheckedBoxesNumber(checkedBoxesNumber + 1);
    }
    else {
      setCheckedBoxesNumber(checkedBoxesNumber - 1);
    }
  };

  const buttonOpenCancellationAgreement = (
    <Button
      type="default"
      buttonText={t('buttons.btn_cancelSubscription')}
      onClick={() => setOpenPlanCancellationAgreement(true)} />
  );

  const planCancellationAgreement = (
    <Modal
      isOpen={openPlanCancellationAgreement}
      isLoading={isLoading || false}
      onClose={(closeModal) => {
        resetCheckboxes();
        setOpenPlanCancellationAgreement(closeModal);
        onClose(closeModal);
      }}
      defaultModalActions={true}
      submitButtonText={t('buttons.btn_agreeAndCancel')}
      cancelButtonText={t('buttons.btn_keepSubscription')}
      onSubmit={async () => {
        if (state.user) {
          try {
            cancelButtonAction ? cancelButtonAction() : await SubscriptionService.handleCancelSubscription(state.user?.organizationId, state.user);

            const hubspotSubCanellationData: HubspotSubCancellationData = {
              organizationName: state.organization.name,
              accountHolderEmail: state.user?.email,
              accountHolderName: `${(state.user?.firstName || "")} ${(state.user?.lastName || "")}`,
              response: selectedReason !== null ? reasons[selectedReason].value : undefined,
              details: details || undefined,
            }

            await HubspotSubCancellationDataService.add(hubspotSubCanellationData, state.user);
            !cancelButtonAction && enqueueSnackbar(t('cancellationDialogBox.subscriptionCancelled'), { variant: "toast", width: "450px" });
          } catch (err: any) {
            enqueueSnackbar(err);
          }

          setOpenPlanCancellationAgreement(false);
          onClose(false);
        }
      }}
      onCancel={() => {
        setOpenPlanCancellationAgreement(false);
        onClose(false);
      }}
      submitDisabled={checkedBoxesNumber !== checkboxes.length}>
      <div className={COMPONENT_CLASS}>
        <h3>{t('cancellationDialogBox.cancelTitle')}</h3>

        <p className={`${COMPONENT_CLASS}__description`}>
          {t('cancellationDialogBox.cancelDesc')}
        </p>

        <div className={`${COMPONENT_CLASS}__checkboxes`}>
          {checkboxes.map((checkbox, index) => {
            return (
              <div key={index} className={`${COMPONENT_CLASS}__checkbox-row`}>
                <div className={`${COMPONENT_CLASS}__checkbox-wrapper`}>
                  <CheckboxTypeInput
                    id={`${COMPONENT_CLASS}__checkbox-${index}`}
                    inputClassName={`${COMPONENT_CLASS}__cancel-subscription-checkbox`}
                    registerHook={register}
                    registerOptions={{
                      onChange: (e) => handleCheckboxChange(e, index)
                    }}
                    checked={checkbox.isChecked} />
                </div>
                <label htmlFor={`${COMPONENT_CLASS}__checkbox-${index}`}>
                  <p><strong>{checkbox.firstLine}</strong></p>
                  <p>{checkbox.secondLine}</p>
                </label>
              </div>
            );
          })}
        </div>

        <p className={`${COMPONENT_CLASS}__description`}>
          {t('cancellationDialogBox.youCanReactivate')}
        </p>
      </div>
    </Modal>
  );

  return (
    openPlanCancellationAgreement ? planCancellationAgreement :
      <Modal
        isOpen={isOpen}
        isLoading={isLoading || false}
        onClose={onClose}
        title={title}
      >
        <div className={COMPONENT_CLASS}>
          <div className="my-8">{t('cancellationDialogBox.reasons.title')}</div>
          <div className={`${COMPONENT_CLASS}__reasons`}>
            {reasons.map((reason, index) => (
              index === 2 ? (

                <div key={index}>
                  <div className={`reason ${selectedReason === index ? 'visible' : ''}`} onClick={() => handleRadioChange(index)} >
                    <div>
                      <RadioTypeInput
                        id={`cancellationReason-${index}`}
                        name="cancellationReason"
                        checked={selectedReason === index}
                      />
                    </div>
                    <label>{reason.value}</label>
                  </div>
                  <div className={`cancellation-details ${selectedReason === index ? 'visible' : ''}`}>
                    <p style={{
                      fontSize: '14px', fontWeight: 'bold',
                    }}>{reason.text}</p>
                    <div className={'contact-us'}>
                      <Button
                        type="default"
                        buttonText="Contact Us"
                        onClick={() => setOpenHubspotForm(!openHubspotForm)} />
                      <div className='cancellation-button-white'>
                        {buttonOpenCancellationAgreement}
                      </div>
                      {openHubspotForm &&
                        <div className={`${COMPONENT_CLASS}__hubspot-form`}>
                          <HubspotForm
                            portalId='5419630'
                            formId='6dc531b3-6919-46fe-982b-af93fa7a0a04'
                            onFormSubmitted={() => {
                              enqueueSnackbar(t('cancellationDialogBox.inquiry'), { variant: "toast", width: "550px" });
                              setOpenHubspotForm(false);
                              setOpenPlanCancellationAgreement(false);
                              onClose(false);
                            }}
                            loading={<div>Loading...</div>}
                          />
                        </div>
                      }
                    </div>

                  </div>
                </div>
              ) : (<div key={index}>
                <div className={`reason ${selectedReason === index ? 'visible' : ''}`} onClick={() => handleRadioChange(index)} >
                  <div>
                    <RadioTypeInput
                      id={`cancellationReason-${index}`}
                      name="cancellationReason"
                      checked={selectedReason === index}
                    />
                  </div>
                  <label>{reason.value}</label>
                </div>
                <div className={`cancellation-details ${selectedReason === index ? 'visible' : ''}`}>
                  <p style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '5px' }}>{reason.text}</p>
                  <TextTypeInput
                    id='test'
                    type='text'
                    label={reason.placeholder}
                    hideLabel={true}
                    className='w-full'
                    registerHook={register}
                    registerOptions={{
                      value: details,
                      onChange: event => { setDetails(event.target.value) },
                    }} />
                  <div className='cancellation-button'>
                    {buttonOpenCancellationAgreement}
                  </div>
                </div>
              </div>)
            ))}
          </div>
        </div>
      </Modal>
  );

};

export default CancellationDialogBox;